import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDuplicate = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_1410_103",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 16,
			height: 16,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_1410_103)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12.6666 5.33356V12.6666H5.33356C5.15674 12.6666 4.98715 12.7368 4.86212 12.8619C4.73709 12.9869 4.66685 13.1565 4.66685 13.3333C4.66685 13.5101 4.73709 13.6797 4.86212 13.8047C4.98715 13.9298 5.15674 14 5.33356 14H13.3333C13.5101 14 13.6797 13.9298 13.8047 13.8047C13.9298 13.6797 14 13.5101 14 13.3333V5.33356C14 5.15674 13.9298 4.98716 13.8047 4.86213C13.6797 4.7371 13.5101 4.66686 13.3333 4.66686C13.1565 4.66686 12.9869 4.7371 12.8619 4.86213C12.7368 4.98716 12.6666 5.15674 12.6666 5.33356ZM11.3332 10.3339V3.00089C11.3333 2.86956 11.3075 2.73949 11.2573 2.61811C11.2072 2.49674 11.1336 2.38643 11.0408 2.29349C10.948 2.20055 10.8378 2.12679 10.7165 2.07644C10.5953 2.02608 10.4652 2.00011 10.3339 2H3.00007C2.73483 2 2.48046 2.10537 2.29291 2.29292C2.10536 2.48047 2 2.73483 2 3.00007V10.3331C2 10.5983 2.10536 10.8527 2.29291 11.0402C2.48046 11.2278 2.73483 11.3332 3.00007 11.3332H10.3339C10.5989 11.3329 10.8529 11.2276 11.0402 11.0402C11.2276 10.8529 11.3329 10.5989 11.3332 10.3339ZM7.99959 7.3337H7.33288V8.0004C7.33288 8.17723 7.26264 8.34682 7.13761 8.47185C7.01257 8.59688 6.84299 8.66713 6.66617 8.66713C6.48934 8.66713 6.31977 8.59688 6.19473 8.47185C6.0697 8.34682 5.99945 8.17723 5.99945 8.0004V7.3337H5.33356C5.15674 7.3337 4.98715 7.26346 4.86212 7.13842C4.73709 7.01339 4.66685 6.84381 4.66685 6.66699C4.66685 6.49017 4.73709 6.32058 4.86212 6.19554C4.98715 6.07051 5.15674 6.00027 5.33356 6.00027H6.00354V5.33356C6.00354 5.15674 6.07378 4.98716 6.19882 4.86213C6.32385 4.7371 6.49343 4.66686 6.67026 4.66686C6.84708 4.66686 7.01666 4.7371 7.14169 4.86213C7.26672 4.98716 7.33696 5.15674 7.33696 5.33356V6.00027H8.00368C8.1805 6.00027 8.35008 6.07051 8.47511 6.19554C8.60014 6.32058 8.67039 6.49017 8.67039 6.66699C8.67039 6.75482 8.65304 6.84178 8.61933 6.92288C8.58562 7.00398 8.53621 7.07763 8.47396 7.13958C8.4117 7.20154 8.33782 7.25058 8.25656 7.28389C8.17529 7.3172 8.08824 7.33413 8.00041 7.3337H7.99959Z"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgDuplicate);
export default ForwardRef;
